<div class="main profil-page">
    <ng-container *ngIf="environment">
        <div class="dx-field-title" translate>profile.pageTitle</div>
        <dx-scroll-view id="scrollview">
            <dx-form class="wrap" #profileForm [formData]="environment" [showValidationSummary]="true" labelLocation="top" [colCount]="2">
                <dxi-item itemType="group" [caption]="'profile.lblGeneral' | translate" [colSpan]="2">
                    <dxi-item class="disabled"
                              editorType="dxSwitch"
                              dataField="enabled"
                              [label]="{ text: 'profile.lblEnableDisable' | translate, location: 'top' }">
                    </dxi-item>
                    <dxi-item dataField="name"
                              editorType="dxTextBox"
                              [editorOptions]="{ width: '500px' }"
                              [label]="{ text: 'profile.lblName' | translate }">
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [caption]="'profile.lblTimers' | translate">
                    <dxi-item dataField="globalTimer"
                              editorType="dxNumberBox"
                              [editorOptions]="{ placeholder: 'profile.lblInSeconds' | translate, width: '200px' }"
                              [label]="{ text: 'profile.lblGlobalTimer' | translate }">
                        <dxi-validation-rule type="range" [min]="60" [max]="84600" [message]="'profile.globalTimerInvalidRange' | translate"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="lamIntervalCheckCommandQueue"
                              editorType="dxNumberBox"
                              [editorOptions]="{ width: '200px' }"
                              [label]="{ text: 'profile.lblLamIntervalCheckCommandQueue' | translate }">
                    </dxi-item>
                    <dxi-item dataField="laIntervalCheckCommandQueue"
                              editorType="dxNumberBox"
                              [editorOptions]="{ width: '200px' }"
                              [label]="{ text: 'profile.lblLaIntervalCheckCommandQueue' | translate }">
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [caption]="'profile.lblAlerts' | translate">
                    <dxi-item dataField="countAttemptsBeforeNotification"
                              editorType="dxNumberBox"
                              [editorOptions]="{ width: '200px' }"
                              [label]="{ text: 'profile.lblCountAttemptsBeforeNotification' | translate }">
                    </dxi-item>
                    <dxi-item dataField="maxDelayToReceiveACK"
                              editorType="dxNumberBox"
                              [editorOptions]="{ placeholder: 'profile.lblInMinutes' | translate, width: '200px' }"
                              [label]="{ text: 'profile.lblMaxAckDelay' | translate }">
                        <dxi-validation-rule type="range" [min]="10" [max]="1440" [message]="'profile.maxAckDelayInvalidRange' | translate"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="laDelayBeforeStopping"
                              editorType="dxNumberBox"
                              [editorOptions]="{ width: '200px' }"
                              [label]="{ text: 'profile.lblLaDelayBeforeStopping' | translate }">
                    </dxi-item>
                </dxi-item>
            </dx-form>
            <br />
        </dx-scroll-view>
        <div class="flex bottom-buttons">
            <dx-button width="auto" class="save" [text]="'_commons.save' | translate" (onClick)="onClickSave()"></dx-button>
            <dx-button width="auto" class="delete" [text]="'_commons.delete' | translate" (onClick)="onClickDelete()"></dx-button>
        </div>
    </ng-container>
</div>

<!-- Loading panel -->
<dx-load-panel [visible]="loading" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }" ></dx-load-panel>
